/*
 * Public API Surface of ngx-input-regulate
 */
export * from './lib/ngx-input-regulate.directive';
export * from './lib/ngx-input-regulate.module';
